import { getMessages } from '../../../../../store/constants';

export const SNACKBAR_RELOAD_TEXT = getMessages().getText('snackbar.reload.text');
